<div class="row mt-2" *ngIf="fraccionamiento">
    <div class="col-4">
        <ca-form-field>
            <ca-label>{{'CATALOGO.DATOS_ADICIONALES.FRACCIONAMIENTO' | translate}}</ca-label>
            <input caInput type="text" [value]="fraccionamiento.descFraccionamiento" disabled/>
        </ca-form-field>
    </div>
</div>
<div class="row mt-2" *ngIf="recibo">
    <div class="col-4">
        <ca-form-field>
            <ca-label>{{'COMUN.DATOS_ECONOMICOS.PRIMA_NETA' | translate}}</ca-label>
            <input caInput type="text" disabled
                [value]="this.recibo.reciboAnualidad?.importePrimaNeta || this.recibo.reciboPrimerPago?.importePrimaNeta || 0 | currency:'EUR':'symbol':'1.2-2'" />
        </ca-form-field>
    </div>
    <div class="col-4">
        <ca-form-field>
            <ca-label>{{'COMUN.DATOS_ECONOMICOS.PRIMA_TOTAL' | translate}}</ca-label>
            <input caInput type="text" disabled
                [value]="this.recibo.reciboAnualidad?.importeTotal || this.recibo.reciboPrimerPago?.importeTotal || 0 | currency:'EUR':'symbol':'1.2-2'" />
        </ca-form-field>
    </div>
</div>
<div class="row mt-2" *ngIf="recibo">
    <div class="col-4">
        <ca-form-field>
            <ca-label>{{'COMUN.DATOS_ECONOMICOS.PRIMER_PAGO' | translate}}</ca-label>
            <input caInput type="text" disabled
                [value]="this.recibo.reciboPrimerPago?.importeTotal || 0 | currency:'EUR':'symbol':'1.2-2'" />
        </ca-form-field>
    </div>
    <div class="col-4">
        <ca-form-field>
            <ca-label>{{'COMUN.DATOS_ECONOMICOS.RESTO_PAGOS' | translate}}</ca-label>
            <input caInput type="text" disabled
                [value]="this.recibo.reciboPagosSucesivos?.importeTotal || 0 | currency:'EUR':'symbol':'1.2-2'" />
        </ca-form-field>
    </div>
</div>